import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  fetchBaseRate,
  fetchSubscriptionTierDetails,
  getStoreValueByProp,
} from '../store/subscriptionsSlice';
import PlanSelection from './PlanSelection';

const mapState = R.applySpec({
  currentBaseRate: getStoreValueByProp(['currentBaseRate']),
  subscriptionTierDetailsLoading: getStoreValueByProp(['subscriptionTierDetailsLoading']),
  subscriptionTiers: getStoreValueByProp(['subscriptionTiers']),
});

const mapDispatch = {
  fetchBaseRate,
  fetchSubscriptionTierDetails,
};

export default connect(mapState, mapDispatch)(PlanSelection);
